import { PublicClientApplication, InteractionRequiredAuthError } from "@azure/msal-browser";

// ── MSAL configuration ───────────────────────────────────────────────────────
// Set REACT_APP_MSAL_CLIENT_ID and REACT_APP_TENANT_ID in your .env.local
// (or Azure Static Web Apps application settings for production).
const MSAL_CLIENT_ID = process.env.REACT_APP_MSAL_CLIENT_ID || '3a314746-fdfa-4b80-b9b2-c0c3f4119d45';
const TENANT_ID      = process.env.REACT_APP_TENANT_ID      || 'e955ad42-7231-4f6c-94ad-5ea367d727e5';

export const msalConfig = {
  auth: {
    clientId:    MSAL_CLIENT_ID,
    authority:   `https://login.microsoftonline.com/${TENANT_ID}`,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation:          "localStorage",
    storeAuthStateInCookie: true,
  },
  system: {
    allowNativeBroker: false,
    iframeHashTimeout: 10000,
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);
msalInstance.initialize().catch(() => {});

const API_CLIENT_ID      = process.env.REACT_APP_API_CLIENT_ID || 'e8772165-ceda-482b-8f05-901e0259740b';
export const API_SCOPE   = `api://${API_CLIENT_ID}/access_as_user`;
export const AUTH_SCOPES = [API_SCOPE, "openid", "profile", "email"];

// Acquire token silently, fall back to popup, then redirect
export async function getAccessToken() {
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length === 0) return null;
  try {
    const result = await msalInstance.acquireTokenSilent({
      scopes:  AUTH_SCOPES,
      account: accounts[0],
    });
    return result.accessToken;
  } catch (err) {
    if (err instanceof InteractionRequiredAuthError) {
      // Session expired — let the app surface a toast before we interrupt the
      // user with a popup/redirect. (auth.js lives outside React, so we bridge
      // via a window event that a listener under ToastProvider turns into a toast.)
      try { window.dispatchEvent(new CustomEvent("harvus-session-expired")); } catch { /* ignore */ }
      try {
        const result = await msalInstance.acquireTokenPopup({ scopes: AUTH_SCOPES });
        return result.accessToken;
      } catch {
        await msalInstance.acquireTokenRedirect({ scopes: AUTH_SCOPES });
      }
    }
    return null;
  }
}
